"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _distribution = require("@/api/distribution");
var _detailUser = _interopRequireDefault(require("@/components/detailUser"));
var _edit = _interopRequireDefault(require("./edit"));
var _level = _interopRequireDefault(require("./level"));
var _userList = _interopRequireDefault(require("@/components/userList"));
var _couponList = _interopRequireDefault(require("../components/couponList"));
var _giftToMembers = _interopRequireDefault(require("../components/giftToMembers"));
var _permission = require("@/utils/permission");
var _validate = require("@/utils/validate");
var _public = require("@/libs/public");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
// 权限判断函数
var _default = exports.default = {
  name: 'UserIndex',
  components: {
    editFrom: _edit.default,
    userList: _userList.default,
    levelEdit: _level.default,
    detailUser: _detailUser.default,
    couponList: _couponList.default,
    giftToMembers: _giftToMembers.default
  },
  data: function data() {
    return {
      registerTypeList: [{
        value: 'wechat',
        label: '公众号'
      }, {
        value: 'routine',
        label: '小程序'
      }, {
        value: 'h5',
        label: 'H5'
      }, {
        value: 'iosWx',
        label: '微信ios'
      }, {
        value: 'androidWx',
        label: '微信安卓'
      }, {
        value: 'ios',
        label: 'ios'
      }],
      formExtension: {
        spreadUid: '',
        userId: ''
      },
      selectedUser: {
        image: '',
        nickname: ''
      },
      ruleInline: {},
      extensionVisible: false,
      userVisible: false,
      levelInfo: '',
      pickerOptions: this.$timeOptions,
      loadingBtn: false,
      PointValidateForm: {
        integral: null,
        operateType: 'add',
        uid: '',
        money: null
      },
      loadingPoint: false,
      VisiblePoint: false,
      visible: false,
      dialogVisible: false,
      levelVisible: false,
      labelData: [],
      selData: [],
      keywords: '',
      labelPosition: 'right',
      collapse: false,
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      userFrom: {
        payCount: '',
        sex: '',
        identity: '',
        registerType: '',
        page: 1,
        limit: 20,
        searchType: 'all',
        content: ''
      },
      grid: {
        xl: 8,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      labelLists: [],
      selectedData: [],
      timeVal: [],
      dynamicValidateForm: {
        groupId: []
      },
      loading: false,
      groupIdFrom: [],
      selectionList: [],
      batchName: '',
      uid: 0,
      Visible: false,
      keyNum: 0,
      multipleSelection: [],
      multipleSelectionAll: [],
      idKey: 'id',
      card_select_show: false,
      checkAll: false,
      checkedCities: ['ID', '头像', '姓名', '注册类型', '推荐人', '联系电话', '余额', '积分'],
      columnData: ['ID', '头像', '姓名', '注册类型', '推荐人', '联系电话', '余额', '积分'],
      isIndeterminate: true,
      type: 'integral',
      userInfo: {},
      checkedIds: [],
      selectAllPage: false,
      visibleCoupon: false,
      //发送优惠券显示
      isBatch: false,
      //是否是批量
      tableDataMember: [],
      //会员卡
      dialogVisibleMember: false,
      checkeduIds: ''
    };
  },
  activated: function activated() {
    this.getList(1);
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['platform:user:page:list'])) this.getList(1);
    if ((0, _permission.checkPermi)(['platform:user:tag:all:list'])) this.getTagList();
    if ((0, _permission.checkPermi)(['platform:paid:member:card:list'])) this.getMemberList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    handleResetSelection: function handleResetSelection() {
      this.handleClearCheckbox();
    },
    sexFilter: function sexFilter(status) {
      var statusMap = {
        0: '未知',
        1: '男',
        2: '女',
        3: '保密'
      };
      return statusMap[status];
    },
    //性别
    getSexImage: function getSexImage(sex) {
      var iconMap = {
        0: 'unknown.png',
        1: 'man.png',
        2: 'woman.png',
        3: 'unknown.png'
      };
      var imageName = iconMap[sex] || 'unknown.png';
      return require("@/assets/imgs/".concat(imageName));
    },
    //赠送会员
    handleGiftMembers: function handleGiftMembers(row) {
      if (!this.multipleSelection.length && !row) return this.$message.warning('请选择用户');
      if (row) {
        this.checkeduIds = row.id;
      } else {
        this.getUserIds();
        this.checkeduIds = this.checkedIds.join(',');
      }
      this.dialogVisibleMember = true;
    },
    handlerSuccessSubmit: function handlerSuccessSubmit() {
      this.handleClearCheckbox();
      this.dialogVisibleMember = false;
    },
    //会员卡列表
    getMemberList: function () {
      var _getMemberList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _user.memberCardListApi)({
                type: 1,
                status: 1
              });
            case 1:
              this.tableDataMember = _context.v;
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getMemberList() {
        return _getMemberList.apply(this, arguments);
      }
      return getMemberList;
    }(),
    filterRegisterType: function filterRegisterType(status) {
      var statusMap = {
        wechat: '#FD5ACC',
        routine: '#A277FF',
        h5: '#E8B600',
        iosWx: '#1BBE6B',
        androidWx: '#EF9C20',
        ios: '#1890FF'
      };
      return statusMap[status];
    },
    // 清除
    clearSpread: function clearSpread(row) {
      var _this = this;
      this.$modalSure('解除【' + row.nickname + '】的上级推广人吗').then(function () {
        (0, _distribution.spreadClearApi)(row.id).then(function (res) {
          _this.$message.success('清除成功');
          _this.getList();
        });
      });
    },
    onSubExtension: function onSubExtension(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          (0, _user.updateSpreadApi)(_this2.formExtension).then(function (res) {
            _this2.$message.success('设置成功');
            _this2.extensionVisible = false;
            _this2.getList();
          });
        } else {
          return false;
        }
      });
    },
    getTemplateRow: function getTemplateRow(row) {
      this.formExtension.spreadUid = row.id;
      this.selectedUser = {
        image: row.avatar,
        nickname: row.nickname
      };
      this.userVisible = false;
    },
    setExtension: function setExtension(row) {
      this.formExtension = {
        spreadUid: '',
        userId: row.id
      };
      this.selectedUser = {
        image: '',
        nickname: ''
      };
      this.extensionVisible = true;
    },
    handleCloseExtension: function handleCloseExtension() {
      this.extensionVisible = false;
      this.selectedUser = {
        image: '',
        nickname: ''
      };
    },
    modalPicTap: function modalPicTap() {
      this.userVisible = true;
    },
    resetForm: function resetForm() {
      this.visible = false;
    },
    handleEditSuccess: function handleEditSuccess() {
      this.visible = false;
      this.getList();
    },
    reset: function reset(formName) {
      this.userFrom.payCount = '';
      this.userFrom.sex = '';
      this.userFrom.identity = '';
      this.userFrom.registerType = '';
      this.userFrom.page = 1;
      this.userFrom.searchType = 'all';
      this.userFrom.content = '';
      this.keywords = '';
      this.labelData = [];
      this.timeVal = [];
      this.getList(1);
    },
    Close: function Close() {
      this.Visible = false;
      this.levelVisible = false;
    },
    // 账户详情
    onDetails: function onDetails(id) {
      this.$refs.userDetailFrom.getUserDetail(id);
      this.$refs.userDetailFrom.dialogUserDetail = true;
    },
    // 积分余额
    editPoint: function editPoint(row, type) {
      this.uid = row.id;
      this.type = type;
      this.userInfo = row;
      this.VisiblePoint = true;
    },
    // 积分余额
    submitPointForm: (0, _validate.Debounce)(function (formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.PointValidateForm.uid = _this3.uid;
          _this3.loadingBtn = true;
          if (_this3.type === 'integral') {
            (0, _user.foundsApi)(_this3.PointValidateForm).then(function (res) {
              _this3.$message.success('设置成功');
              _this3.loadingBtn = false;
              _this3.handlePointClose();
              _this3.getList();
            }).catch(function () {
              _this3.loadingBtn = false;
            });
          } else {
            (0, _user.balanceApi)(_this3.PointValidateForm).then(function (res) {
              _this3.$message.success('设置成功');
              _this3.loadingBtn = false;
              _this3.handlePointClose();
              _this3.getList();
            }).catch(function () {
              _this3.loadingBtn = false;
            });
          }
        } else {
          return false;
        }
      });
    }),
    // 积分余额
    handlePointClose: function handlePointClose() {
      this.VisiblePoint = false;
      this.PointValidateForm = {
        integral: null,
        operateType: 'add',
        uid: '',
        money: null
      };
    },
    editUser: function editUser(row) {
      this.userInfo = row;
      this.visible = true;
    },
    // 设置用户标签
    submitForm: (0, _validate.Debounce)(function (formName) {
      var _this4 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this4.getUserIds();
          _this4.loading = true;
          (0, _user.tagPiApi)({
            tagIds: _this4.dynamicValidateForm.groupId.join(','),
            ids: _this4.checkeduIds
          }).then(function (res) {
            _this4.$message.success('设置成功');
            _this4.loading = false;
            _this4.handleClose();
            _this4.getList();
          }).catch(function () {
            _this4.loading = false;
          });
        } else {
          return false;
        }
      });
    }),
    setBatch: function setBatch(name, row, num) {
      var _this5 = this;
      num === 1 ? this.isBatch = true : this.isBatch = false;
      this.batchName = name;
      if (row) {
        this.checkeduIds = row.id;
      } else {
        this.getUserIds();
        this.checkeduIds = this.checkedIds.join(',');
      }

      // if (row) this.checkedIds = row.id;
      //  this.dynamicValidateForm.groupId = ''
      if (this.multipleSelection.length === 0 && !row) return this.$message.warning('请选择要设置的用户');
      this.dialogVisible = true;
      this.$nextTick(function () {
        _this5.$refs.dynamicValidateFormRef.clearValidate();
      });
    },
    //清除选中
    handleClearCheckbox: function handleClearCheckbox() {
      this.$refs.table.clearSelection();
      this.multipleSelectionAll = [];
    },
    handleClose: function handleClose() {
      this.handleClearCheckbox();
      this.dialogVisible = false;
      this.$refs.dynamicValidateFormRef.resetFields();
    },
    // 搜索
    userSearchs: function userSearchs() {
      this.userFrom.page = 1;
      this.getList();
    },
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.userFrom.dateLimit = e ? this.timeVal.join(',') : '';
    },
    //标签列表
    getTagList: function getTagList() {
      var _this6 = this;
      (0, _user.tagAllListApi)().then(function (res) {
        _this6.labelLists = res;
        localStorage.setItem('tagAllList', JSON.stringify(res));
      });
    },
    // 列表
    getList: function getList(num) {
      var _this7 = this;
      this.listLoading = true;
      this.userFrom.page = num ? num : this.userFrom.page;
      this.userFrom.tagIds = this.labelData.join(',');
      (0, _user.userListApi)(this.userFrom).then(function (res) {
        _this7.tableData.data = res.list;
        _this7.tableData.total = res.total;
        _this7.$nextTick(function () {
          this.setSelectRow(); // 调用跨页选中方法
        });
        _this7.listLoading = false;
      }).catch(function () {
        _this7.listLoading = false;
      });
      this.checkedCities = this.$cache.local.has('user_stroge') ? this.$cache.local.getJSON('user_stroge') : this.checkedCities;
      this.$set(this, 'card_select_show', false);
    },
    // 设置选中的方法
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.tableData.data.length; i++) {
        if (selectAllIds.indexOf(this.tableData.data[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.tableData.data[i], true);
        }
      }
    },
    // 设置选中的方法
    handleSelectionChange: function handleSelectionChange(val) {
      var _this8 = this;
      this.multipleSelection = val;
      setTimeout(function () {
        _this8.$selfUtil.changePageCoreRecordData(_this8.multipleSelectionAll, _this8.multipleSelection, _this8.tableData.data, function (e) {
          _this8.multipleSelectionAll = e;
        });
      }, 50);
    },
    pageChange: function pageChange(page) {
      var _this9 = this;
      this.$selfUtil.changePageCoreRecordData(this.multipleSelectionAll, this.multipleSelection, this.tableData.data, function (e) {
        _this9.multipleSelectionAll = e;
      });
      this.userFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      var _this0 = this;
      this.$selfUtil.changePageCoreRecordData(this.multipleSelectionAll, this.multipleSelection, this.tableData.data, function (e) {
        _this0.multipleSelectionAll = e;
      });
      this.userFrom.limit = val;
      this.getList(1);
    },
    // 删除
    handleDelete: function handleDelete(id, idx) {
      var _this1 = this;
      this.$modalSure().then(function () {
        productDeleteApi(id).then(function () {
          _this1.$message.success('删除成功');
          (0, _public.handleDeleteTable)(_this1.tableData.data.length, _this1.userFrom);
          _this1.getList();
        });
      });
    },
    onchangeIsShow: function onchangeIsShow(row) {
      var _this10 = this;
      row.isShow ? putOnShellApi(row.id).then(function () {
        _this10.$message.success('上架成功');
        _this10.getList();
      }).catch(function () {
        row.isShow = !row.isShow;
      }) : offShellApi(row.id).then(function () {
        _this10.$message.success('下架成功');
        _this10.getList();
      }).catch(function () {
        row.isShow = !row.isShow;
      });
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('user_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    // 获取批量用户ids
    getUserIds: function getUserIds() {
      var data = [];
      this.multipleSelectionAll.map(function (item) {
        data.push(item.id);
      });
      this.checkedIds = data;
    },
    //发送优惠券
    sendCoupon: function sendCoupon() {
      if (this.multipleSelection.length > 0) {
        this.getUserIds();
        this.visibleCoupon = true;
      } else {
        this.$message.warning('请选择用户');
      }
    },
    sendSuccess: function sendSuccess() {
      this.handleClearCheckbox();
      this.visibleCoupon = false;
    }
  }
};